import { Tabs } from "antd";
import { Button } from "antd";
import { Modal } from "antd";
import React, { FC } from "react";

type EnhancementProcedureForCghsModalProps = {
  addNewEnhancementModal: boolean;
  items: any;
  activeKey: string;
  onChangeKey: any;
  handleCancel: () => void;
  handleSubmit: any;
  isFetchingPortalData: boolean;
};

const EnhancementProcedureForCghsModal: FC<
  EnhancementProcedureForCghsModalProps
> = (props) => {
  return (
    <Modal
      visible={props?.addNewEnhancementModal}
      title="New Enhancement Case"
      centered
      width={1200}
      loading={props?.isFetchingPortalData}
      footer={[
        <Button key="back" onClick={props?.handleCancel}>
          Cancel
        </Button>,

        props?.activeKey === "2" ? (
          <Button
            type="primary"
            htmlType="submit"
            style={{
              border: "1px solid darkcyan",
              background: "darkcyan",
              fontSize: "14px",
              fontWeight: "400",
              color: "white",
            }}
            onClick={props?.handleSubmit}
          >
            SUBMIT
          </Button>
        ) : (
          <></>
        ),
      ]}
      onCancel={props?.handleCancel}
      //   onOk={handleSubmit}
      //   okButtonProps={{ loading: isSaving, disabled: isSaving }}
      //   cancelButtonProps={{ disabled: isSaving }}
      //   okText={isSaving ? "Saving..." : "Save"}
      style={{ top: 20 }}
    >
      <Tabs
        activeKey={props?.activeKey}
        type="card"
        size="large"
        style={{ width: "100%" }}
        items={props?.items}
        onChange={props?.onChangeKey}
      />
    </Modal>
  );
};

export default EnhancementProcedureForCghsModal;
